(ns ycweb.app.dashboard.orderview
  (:require
    [inflections.core :as inflections]
    [ycweb.util.date :as ud]
    [ycweb.util.core :as u]
    [rum.core :as rum]
    [ycweb.components.common :as cmn]
    [clojure.set :as set]
    [ycweb.util.comms :as comms]
    [ycweb.app.dashboard.common :as dcommon]
    [ycweb.components.flow :as flow]))


(def shipping-statuses
  {:supplierclosed {:priority 1 :fg "#E06666" :bg "#F4CCCC" :title "Supplier closed"}
   :discontinued {:priority 2 :fg "#E06666" :bg "#F4CCCC" :title "Discontinued"}
   :notavailable {:priority 3 :fg "#E06666" :bg "#F4CCCC" :title "Not available at supplier"}
   :notavailable-expected {:priority 4 :fg "#E06666" :bg "#F4CCCC" :title "Not available at supplier, has expected date"}

   :none {:priority 5 :fg "#E69138" :bg "#FCE5CD" :title "Unknown Status"}
   :no-stock {:priority 6 :fg "#E69138" :bg "#FCE5CD" :title "No stock order placed"}
   :stockproblem {:priority 7 :fg "#E69138" :bg "#FCE5CD" :title "Stock problem"}

   :stockorder-provisional {:priority 8 :fg "#FFD966" :bg "#FFF2CC" :title "On stockorder, provisionally allocated"}
   :stockorder-prereceived {:priority 9 :fg "#FFD966" :bg "#FFF2CC" :title "Pre-received, fully allocated"}
   :stockorder-claimed {:priority 9 :fg "#FFD966" :bg "#FFF2CC" :title "On stockorder, fully allocated"}
   :bom {:priority 10 :fg "#FFD966" :bg "#FFF2CC" :title "BOM - Need to manufacture."}

   :not-shippable-variation {:priority 11 :fg "#B4A7D6" :bg "#D9D2E9" :title "Not shippable product"}
   :not-shippable-qty {:priority 12 :fg "#B4A7D6" :bg "#D9D2E9" :title "Not shippable, invalid quantity"}

   :dropship-ordered {:priority 13 :fg "#D5A6BD" :bg "#D5A6BD" :title "Dropship Ordered"}
   :dropship-pending {:priority 14 :fg "#D5A6BD" :bg "#D5A6BD" :title "Dropship Pending"}

   :pending-allocation {:priority 15 :fg "#93C47D" :bg "#D9D2E9" :title "Pending Allocations"}
   :allocated {:priority 16 :fg "#93C47D" :bg "#D9EAD3" :title "Allocated"}
   :queued {:priority 17 :fg "#a3d48D" :bg "#e9fAe3" :title "Picking Queued"}
   :picking {:priority 18 :fg "#93C47D" :bg "#D9EAD3" :title "Picking"}
   :picked {:priority 19 :fg "#93C47D" :bg "#D9EAD3" :title "Picked, all in packlane"}
   :packed {:priority 20 :fg "#93C47D" :bg "#D9EAD3" :title "Packed, not shipped"}
   :shippable {:priority 21 :fg "#93C47D" :bg "#D9EAD3" :title "Shippable"}

   :essentials-level {:priority 22 :fg "#D9EAD3" :bg "#D9EAD3" :title "Has non-approved items"}

   :fully-shipped {:priority 23 :fg "#B7B7B7" :bg "#EFEFEF" :title "Fully shipped"}

   :unknown {:priority 24 :fg "#ffffff" :title "No status"}})

(defn shippingstatus-info [{:keys [status]}]
  (or
    (get shipping-statuses status)
    (get shipping-statuses :unknown)))

(defonce detail-queue (atom {:summary #{} :detail #{}}))

(defn setup-detail-queue-bounce [app-atom]
  (cmn/debounce-atom detail-queue 100
    (fn [{:keys [summary detail]}]
      (swap! detail-queue update :summary set/difference summary)
      (swap! detail-queue update :detail set/difference detail)

      (when-not (empty? summary)
        (comms/send :order/list-detail {:orderids summary :summary? true}))

      (when-not (empty? detail)
        (comms/send :order/list-detail {:orderids detail :summary? false})))))

(defn teardown-detail-queue-bounce [app-atom]
  (remove-watch detail-queue :bounce-watch))

(defn queue-detail-load [orderid summary?]
  (swap! detail-queue update (if summary? :summary :detail) conj orderid))

;; See views/templates/yuppiechef/desktop/ecommerce/orders/itemtable.tpl
(rum/defc itemline < rum/static [show-essentials-level? {:keys [weber-host] :as integrate} customer-view order item]
  (let [{:keys [fg bg full]} (shippingstatus-info (:shippingstatus item))
        hideqty? (= (get-in item [:shippingstatus :status]) :not-shippable-variation)
        partshipline? (< (:qtyminship item) (- (:qty item) (:qtyshipped item)))
        [full fg bg]
        (if partshipline?
          [true (u/darken-colour bg 0.9) (u/darken-colour bg 0.9)]
          [full fg bg])]

    [:tr
     {:style
      {:background
       (if full bg)}}

     [:td.u-text-right
      {:style {:background fg}}
      [:b (:qty item)]]

     [:td
      [:a
       {:href (str "/admin/products_edit.htm?overrideincludes=popup&sm[e1][action]=contentedit&sm[e1][cntid]=" (:contentid item))
        :target "_blank"}
       (:name item)]]
     (when show-essentials-level?
       (if (and (or (= (:delivery item) "dropship") (not (u/presence (:delivery item)))) (:essentialgood item))
         [:td
          {:class
           (when (and (or (= (:delivery item) "dropship") (not (u/presence (:delivery item)))) (:essentialgood item))
             (u/bem :cell-status
               [(if (:essentialshippable? item) :is-better :is-error)]))}
          (:essentialgood item)]
         [:td]))
     [:td (:code item)]
     ;; TODO: Get this.... Probably some fancy footwork - solr might be a good idea.
     [:td (u/glue ", " (:feature1 item) (:feature2 item))]
     [:td.u-text-right "R" (:price item)]
     [:td.u-text-right
      {:class
       (u/bem :cell-status
         [(if (< (:qtyalloc item) (:qtypicking item)) :is-warning)
          (if (= (:qtyalloc item) (:qtypicking item)) :is-success)])}
      (if hideqty?
        ""
        [:a
         {:target "_blank"
          :href (str weber-host "/admin/reports/history/" (:uuid order) "#tab-allocations")}
         (:qtyalloc item)]
        )]
     [:td.u-text-right (when-not hideqty? (:qtypicking item))]
     [:td.u-text-right (when-not hideqty? (:qtyshipped item))]

     [:td
      {:style {:background bg}}
      (when partshipline?
        [:div [:b "Min ship: " (:qtyminship item)]])
      (str (get-in item [:shippingstatus (if customer-view :customermessage :message)]))]

     [:td
      [:a
       {:target "_blank"
        :href (str "/admin/freestock.htm?variationid=" (:variationid item))}
       "M"]
      " "
      [:a
       {:target "_blank"
        :href (str weber-host "/admin/inspect/view-uuid/" (:vuuid item))}
       "W"]]]))

(rum/defcs order-inspect < rum/reactive (rum/local {:customer-view false} ::state) [s show-essentials-level? integrate order]
  (when-not (:l order)
    (queue-detail-load (:id order) false))

  (let [local-atom (::state s)
        local (rum/react local-atom)]
    [:div
     [:table
      {:class (u/bem :oTable [:has-shadow, :sub-table])}
      [:thead
       [:th.u-text-right "Purchased"]
       [:th "Product"]
       (when show-essentials-level?
         [:th "E.lvl"])
       [:th "Code"] [:th]
       [:th.u-text-right "Price"]
       [:th.u-text-right "Allocated"]
       [:th.u-text-right "Picking"]
       [:th.u-text-right "Shipped"]
       [:th "Message ("
        [:a
         {:style {:color "white" :cursor "pointer"}
          :on-click #(swap! local-atom update :customer-view not)}
         (if (:customer-view local)
           "CS View"
           "Customer View")]
        ")"]
       [:th]]
      (into
        [:tbody]

        (->>
          (:items order)
          (sort-by (comp :priority :shippingstatus))
          (partition-by (comp :group :shippingstatus))
          (mapcat
            (fn [is]
              (concat
                [[:tr
                  [:td {:colSpan 13 :style {:font-size "8px" :padding-top "1px" :padding-bottom "1px"}}
                   " " #_(u/safe-name (get-in (first is) [:shippingstatus :group]))]]]
                (map
                  (partial itemline show-essentials-level? integrate (:customer-view local) order)
                  is))))))]]))

(rum/defc orderlist-item < rum/static
  [order status-lookup show-essentials-level? {:keys [weber-host] :as integrate} opened? open-fn]
  (when-not (:l order)
    (queue-detail-load (:id order) true))

  (list
    [:tr.orderline
     {:key 1
      :on-click #(open-fn order (not opened?))
      :style
      {:cursor "pointer"}
      :class
      [(when (:yellow order) "alert")]
      }

     [:td (get status-lookup (:status order)) #_(:country order)]
     ;; YC Number and registry linky links.
     [:td
      [:a
       {:target "_blank"
        :href (str "/admin/orders.htm?overrideincludes=popup&sm[order1][id]=" (:id order))}

       (:site order) (:id order)]

      (when (:future order) [:span [:br] "Future Ship"])
      (when (:registryid order)
        [:span
         [:br]
         [:a
          {:target "_blank"
           :href (str "/registry/" (:id order))}
          "View"]
         " | "
         [:a
          {:target "_blank"
           :href (str "/admin/registryadmin.htm?overrideincludes=popup&id=" (:id order) "&action=printpurchases")}
          "Purch"]
         " | "
         [:a
          {:target "_blank"
           :href (str "/admin/registries.htm?action=detail&id=" (:id order))}
          "Edit"]
         [:br]
         [(if (not= (:eventtype order) "Wedding") :strong :span)
          (:eventtype order)]])]

     ;; Name
     [:td (:firstname order) " " (:lastname order)]

     [:td
      [:a
       {:href (str "/admin/payments.htm?overrideincludes=popup&sm[pay1][orderid]=" (:id order))}
       (if (pos? (:eventdate order)) (ud/php-elapsed (:eventdate order)) "N/A")]]

     [:td
      (if (pos? (:hideuntil order)) (ud/php-elapsed (:hideuntil order)) "N/A")]

     [:td.u-text-right
      [:a
       {:href (str "/admin/payments.htm?overrideincludes=popup&sm[pay1][orderid]=" (:id order))}
       "R" (u/number-format (:totalincome order) 2)]]

     (cond
       (:s order)
       (let [shipping (:shippingstatus order)
             {:keys [fg]} (shippingstatus-info shipping)
             others (:otherproblemcount shipping)]
         (into
           [:td {:style {:background fg :font-size "10px"}}
            (:message shipping)]
           (cond
             (= 1 others) [[:br] [:i " - " [:b 1] " more problem line"]]
             (pos? others) [[:br] [:i " - " [:b others] " more problem lines"]])))

       :else
       [:td "Loading..."])

     [:td
      (cond
        (nil? (:leadtime order)) "?"
        (zero? (:leadtime order)) "Today"
        (< (:leadtime order) 14) (str (inflections/pluralize (:leadtime order) "day"))
        (< (:leadtime order) 46) (str "about " (inflections/pluralize (Math/round (float (/ (:leadtime order) 7))) "week"))
        :else (str "about " (inflections/pluralize (Math/round (float (/ (:leadtime order) 30))) "month")))]

     [:td.u-text-center
      (dcommon/hover-tooltip
        [:a "N"]
        (map
          (fn [n]
            [:div
             {:style
              {:margin-left "5px" :margin-bottom "10px"
               :padding "5px"
               :background "white"
               :width "400px"
               :border "1px solid black"}} n])
          (:notes order)))
      " "
      [:a
       {:href (str "/admin/letters.htm?overrideincludes=popup&letter=&id=" (:id order)) :target "_blank"}
       "L"]

      " "
      [:a
       {:href (str "/admin/letters.htm?overrideincludes=popup&letter=updateorderstatus.php&id=" (:id order)) :target "_blank"}
       "U"]

      " "
      [:a
       {:target "_blank"
        :href (str weber-host "/admin/reports/history/" (:uuid order))} "W"]]
     ]

    (when opened?
      [:tr
       [:td {:colSpan 9}
        (order-inspect show-essentials-level? integrate order)]])))

(rum/defc order-view < rum/reactive [app-atom]
  (orderlist-item
    (cmn/curact app-atom [:orderview :order])
    (cmn/curact app-atom [:dashboard :status-lookup])
    (pos? (or (cmn/curact app-atom [:config :essentialgoods :shippinglevel]) 0))
    (cmn/curact app-atom [:config :integrate])
    true
    (fn [& _])))

(defmethod flow/render-screen :orderview/order [app-atom _]
  (order-view app-atom))
